"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const store_1 = require("../../store");
const conversation_1 = require("../../slices/conversation");
const colors_1 = require("../../common/colors");
const AppTooltip_1 = __importDefault(require("../AppTooltip"));
const useDevice_1 = require("../../hooks/useDevice");
const AutoPlayButton = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const isAutoPlay = (0, react_redux_1.useSelector)(conversation_1.selectAutoPlay);
    const [hoveredAutoPlay, setHoveredAutoPlay] = (0, react_1.useState)(false);
    const { isMobileScreen } = (0, useDevice_1.useDevice)();
    const handleAutoPlayPress = (0, react_1.useCallback)(() => {
        dispatch((0, conversation_1.toogleAutoPlay)());
    }, [dispatch]);
    return ((0, jsx_runtime_1.jsx)(AppTooltip_1.default, { label: "Auto Read Responses", children: (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: handleAutoPlayPress, onHoverIn: () => setHoveredAutoPlay(true), onHoverOut: () => setHoveredAutoPlay(false), style: styles.autoPlayButton, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: isAutoPlay ? pro_solid_svg_icons_1.faPlayCircle : pro_light_svg_icons_1.faPlayCircle, color: isAutoPlay ? colors_1.Colors.PRIMARY_BLUE : colors_1.Colors.white, size: isMobileScreen ? 24 : 20, style: { opacity: hoveredAutoPlay ? 0.7 : 1 } }) }) }));
};
const styles = react_native_1.StyleSheet.create({
    autoPlayButton: {
        justifyContent: 'center',
    },
});
exports.default = AutoPlayButton;
